export const GetFormAuthParam = function(){
    var today = new Date();
    return btoa(today.toUTCString());
}